import {z} from 'zod';

/**
 * All course feature flags that are supported. When adding a new feature, make
 * sure to add it to the `ALL_SUPPORTED_FEATURES` array and then update the
 * `DEFAULT_STUDENT_FEATURES` and `DEFAULT_SL_FEATURES` arrays.
 */
export const ALL_SUPPORTED_FEATURES = [
  'aboutcourse',
  'appreciation',
  'calendar',
  'chatgpt',
  'code-pages',
  'connections',
  'eager-section-feedback',
  'events',
  'forums',
  'grades',
  'home',
  'html',
  'learn',
  'music',
  'portfolio',
  'puzzles',
  'research',
  'section',
  'section-practice',
  'section-slide-copies',
  'sectionShadowing',
  'stories',
  'studenthome',
  'tailored-puzzles',
  'teaching-puzzles',
  'teachnow',
  'toolbox',
  'training',
  'waiting-room-chatbox',
] as const;

/**
 * A string that represents a course feature.
 */
export type CourseFeature = (typeof ALL_SUPPORTED_FEATURES)[number];

/** Zod schema for a single course feature string. */
export const CourseFeatureSchema = z.enum(ALL_SUPPORTED_FEATURES);

/**
 * The default features enabled for a student.
 */
export const DEFAULT_STUDENT_FEATURES: CourseFeature[] = [
  'aboutcourse',
  'chatgpt',
  'code-pages',
  'connections',
  'events',
  'forums',
  'grades',
  'home',
  'html',
  'learn',
  'section',
  'stories',
  'teachnow',
];

/**
 * The default features enabled for a section leader.
 */
export const DEFAULT_SL_FEATURES: CourseFeature[] = [
  'aboutcourse',
  'chatgpt',
  'code-pages',
  'connections',
  'events',
  'forums',
  'grades',
  'home',
  'html',
  'learn',
  'section',
  'stories',
  'studenthome',
  'teachnow',
  'training',
];
